import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {Validators, FormBuilder, FormGroup } from '@angular/forms';

import { ProductFilterPrototyp } from '../../assets/shared/product-filter.object';
import { RcsConnectorIndexDbProvider } from '../../providers/rcs-connector-index-db/rcs-connector-index-db';
import { FullTextSearch } from '../../providers/rcs-connector-index-db/fulltextsearch';
import { LoadingController, Loading } from 'ionic-angular';

@Component({
  selector: 'product-search',
  templateUrl: 'product-search.html'
})
export class ProductSearchComponent implements OnInit{

    @Input() product_state: string
    @Output() product = new EventEmitter()
    private filter:ProductFilterPrototyp    
    public products: Array<any> = []
    public show_categories: boolean = false
    public show_products: boolean = false
    public progress: any = {}
    public search_button: boolean
    private loading: Loading
    private search_form: FormGroup

    constructor(
        private db: RcsConnectorIndexDbProvider,
        private formBuilder: FormBuilder,
        public loading_controller: LoadingController
        ){
        this.search_form = this.formBuilder.group({
            product: ['', Validators.required],
        });
    }

    ngOnInit(){
        this.filter = new ProductFilterPrototyp();
        this.filter.categories = "fulltext_search";
        this.filter.sort_ascending = true;
        this.search_button = true;
     }

     public show_mode_categories(mode: string){
         if (mode === 'on'){
             this.show_categories = true;
         }else{
             this.show_categories = false;
         }
     }

     private load(){
       this.loading = this.loading_controller.create({
         content: 'Produkte werden gesucht'
       });
       this.loading.present();
     }

      public clear_filter(){
        this.show_products = false;
        this.progress = {}
        this.products = [];
      }

      public search(){
        this.search_button = false;
        this.load();
        this.products = []
        const terms = new FullTextSearch().tokenize(this.filter.search_value, 'en');
        this.progress.max = terms.length;
        this.progress.min = 0;
        if (terms.length !== 0){
          this.db.search('products', this.filter.categories, terms[0]).subscribe(
            result => {
              this.progress.min ++;
              if (terms.length > 1){
                this.regex_search(result, terms);
              }else{
                this.loading.dismiss();
                this.show_products = true;
                this.products = result;
                this.search_button = true;
              }
            },
            error => { console.log(error) },
          )
        }
      }

      private regex_search(products, terms){
        terms.shift()
        for (let term of terms){
          let results = []
          this.progress.min ++;
          for (let product of products){
            const regex = new RegExp(term, 'i');
            if (product.supplier_product_code === false){
              product.supplier_product_code = '';
            }
            if (product.name.match(regex) !== null || product.supplier_product_code.match(regex) !== null || product.seller_name.match(regex) !== null || product.description.match(regex) !== null || product.default_code_tmpl.match(regex) !== null){
              results.push(product);
            }
          }
          this.show_products = true;
          products = results;
        }
        this.loading.dismiss();
        this.show_products = true;
        this.search_button = true;
        this.products = this.sort(products);
      }

      public sort(products:Array<any>){
        let sort_ascending = this.filter.sort_ascending;
        let sorted_products = products.sort(function(a, b){
          if (a.name && b.name){
            if (sort_ascending === false){
              if (a.name.toUpperCase() > b.name.toUpperCase()) { return 1 }
              return 0;
            }else{
              if (a.name.toUpperCase() < b.name.toUpperCase()) { return 1 }
              return 0;
            }
          }
        });
        return sorted_products;
      }

      public send(product){
          this.product.emit(product);
      }
}



// WEBPACK FOOTER //
// ./src/components/product-search/product-search.ts